import React from 'react';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar'
import BipBip from '../../images/bipbip2.png'
import Coyotte from '../../images/coyotte2.png'


import Selection from './Selection';
import PresenceCivilite from '../UtilityScripts/PresenceCivilite'
import getBackgroundColor from '../UtilityScripts/Colors'
import generateOptions from '../UtilityScripts/OptionsPresence'

import Nourriture from '../Pots/Nourriture'
import PseudoNomPrenom from '../UtilityScripts/PseudoNomPrenom'

import DeleteExterieur from '../Administration/DeleteExterieur'
import DeleteInvite from '../Administration/DeleteInvite'


const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  avatar: {
    marginTop: -11,
    padding: 0,
    backgroundColor: "#ff7bdb"
  },
  avatarSelections: {
    width: 20,
    height: 20,
    color: "#000000",
    backgroundColor: "#ffffff",
    marginLeft: -12,
    marginTop: -12,
    paddingLeft: 0,
  },
  card: {
    marginTop: 5,
    marginBottom: 5,
    height: 50,
  },
  superCard: {
    marginTop: 5,
    marginBottom: 5,
    height: 50,
  },
  titre: {
    marginTop: -14,
    marginBottom: -7,
  },
  covidVaccine: {
    color: theme.palette.primary.main
  },
  covidPCR: {
    color: "#f114ff"
  },
  covidCovide: {
    color: "black"
  },
  covidInconnu: {
    color: "#ff1414"
  }
}));


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});




export default function MyCard(props) {
  const classes = useStyles();
  const { sportif, options, handleUpdateSportif, handleSaveCoach, highlight, selection, updateable, handleUpdatePot, handleDeleteExterieur, handleDeleteInvite, affichagePseudos, superUser, futureDate, trainingOrMatch, userId } = props;
  const [open, setOpen] = React.useState(false);
  var backgroundColor = getBackgroundColor(sportif)

  const pot = (trainingOrMatch === 'pots')

  //Should we ever show the user's card differently
  if (highlight) {
    classes.myCard = classes.superCard
  }
  else {
    classes.myCard = classes.card
  }


  //Que faire quand on définit une présence ?
  function setPresence(pres) {
    sportif['present'] = pres
    handleUpdateSportif(sportif)

    //On ne ferme pas dans tous les cas suivants :
    // - le coach est en train de faire une séléction
    // - c'est un pot et on doit renseigner la nourriture
    if (selection || pot) {
      return
    }
    else {
      handleClose()
    }
  }

  //Options de présence (à modifier pour le coach)
  var dialogOptions = generateOptions(options, sportif, setPresence)

  //Sauvegarde depuis l'interface coach pour une séléction
  function handleSave() {
    handleSaveCoach(sportif)
    handleClose()
  }

  //Sauvegarde depuis l'interface pot
  function handleSavePot() {
    handleUpdatePot(sportif)
    handleClose()
  }

  //Modification d'un Extérieur
  function handleExterieur(sportif, del) {
    handleDeleteExterieur(sportif, del)
    handleClose()
  }

  //Modification d'un invité
  function handleInvite(sportif, del) {
    handleDeleteInvite(sportif, del)
    handleClose()
  }

  //On peut cliquer sur un sportif dans tous ces cas :
  // - la date n'est pas encore passée ET qu'on modifie sa présence ou celle d'un copain
  // - on est superUser (cf ListeSportifs.jsx)
  // - on édite un invité qu'on a ajouté nous-même
  const handleClickOpen = () => {
    if ((futureDate && updateable) || superUser) {
      setOpen(true);
    }
  };

  //Fermeture du tiroir
  const handleClose = () => {
    setOpen(false);
  };


  var affichageNomPrenomPseudo = PseudoNomPrenom(sportif, affichagePseudos)

  //Affichage de Présent ou Présente en fonction de la civilité
  let presentCiv
  if (!pot) {
    presentCiv = PresenceCivilite(sportif, sportif['present'])
  }
  else if (pot) {
    var nourriture = []
    if (sportif['boissons']) {
      nourriture.push(sportif['boissons'])
    }
    if (sportif['sucre']) {
      nourriture.push(sportif['sucre'])
    }
    if (sportif['sale']) {
      nourriture.push(sportif['sale'])
    }
    if (sportif['autres']) {
      nourriture.push(sportif['autres'])
    }
    if (nourriture.length === 0) {
      presentCiv = <div>&nbsp;</div>
    }
    else {
      presentCiv = nourriture.join(' - ')
    }
  }


  //S'agit-il du coach qui fait des séléctions ?
  let selectionStuff, nbSelections
  if (selection) {
    selectionStuff = <Selection sportif={sportif} handleSave={handleSave} />
    nbSelections = (
      <Grid item xs={1}>
        <Avatar variant="rounded" className={classes.avatarSelections}>
          <Typography variant='caption'>
            {sportif['nbSelections']}
          </Typography>
        </Avatar>
      </Grid>
    )
  }

  //S'agit-il d'un pot ?
  let potStuff
  if (pot) {
    potStuff = <Nourriture
      sportif={sportif}
      handleSave={handleSavePot} />
  }

  // S'agit-il de l'édition d'un extérieur ?
  let exterieurStuff
  if (sportif['present'] === 'Extérieur(e)' && superUser) {
    exterieurStuff = <DeleteExterieur
      sportif={sportif}
      handleDelete={handleExterieur}
    />
  }

  // S'agit-il de l'édition d'un invité ?
  let inviteStuff
  if (sportif['present'] === 'Invité(e)' && (sportif['pushedBy'] === userId || superUser)) {
    inviteStuff = <DeleteInvite
      sportif={sportif}
      handleDelete={handleInvite}
    />
  }

  //S'agit-il d'un joueur sélectionné ?
  if (sportif['selectionne'] && sportif['selectionne']['selectionne']) {
    //Choix de l'avatar
    let photo
    if (sportif['civilite'] === 'bipbip') {
      photo = BipBip
    }
    else {
      photo = Coyotte
    }
    var avatar = (
      <Avatar alt="X" src={photo} className={classes.avatar} />
    )
    //Renseignement du ou des postes
    var postes = []
    if (sportif['selectionne']['passe']) {
      postes.push('Passe')
    }
    if (sportif['selectionne']['centre']) {
      postes.push('Centre')
    }
    if (sportif['selectionne']['quatre']) {
      postes.push('Poste 4')
    }
    if (postes.length === 0) {
      presentCiv = 'Complet'
    }
    else {
      presentCiv = postes.join('/')
    }
  }


  return (
    <Container maxWidth="xs" >
      <Card className={classes.myCard} elevation={4}
        style={{ backgroundColor }} onClick={handleClickOpen}
      >
        <CardActionArea >
          <CardContent>
            {/* <Grid container direction="row"> */}

            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <Grid item xs={1}>
                {nbSelections}
              </Grid>

              <Grid item xs>
                <Typography className={classes.titre} variant="subtitle1">
                  {affichageNomPrenomPseudo}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {presentCiv}
                </Typography>
              </Grid>

              <Grid item xs={1}>
                {avatar}
              </Grid>

            </Grid>

            {/* </Grid> */}


          </CardContent>
        </CardActionArea>
      </Card>


      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {sportif['nom'] + ' ' + sportif['prenom']}
            </Typography>
          </Toolbar>
        </AppBar>
        <List>
          {dialogOptions}
        </List>
        {selectionStuff}
        {potStuff}
        {inviteStuff}
        {exterieurStuff}
      </Dialog>
    </Container >
  );
}